/**
 * Printer Types
 * Types for thermal printer configuration and ticket printing
 */

export enum PrinterBrand {
  EPSON = 'EPSON',
  STAR = 'STAR',
  BEMATECH = 'BEMATECH',
  ELGIN = 'ELGIN',
  DARUMA = 'DARUMA',
  OTHER = 'OTHER',
}

export const PRINTER_BRAND_LABELS: Record<PrinterBrand, string> = {
  [PrinterBrand.EPSON]: 'Epson',
  [PrinterBrand.STAR]: 'Star',
  [PrinterBrand.BEMATECH]: 'Bematech',
  [PrinterBrand.ELGIN]: 'Elgin',
  [PrinterBrand.DARUMA]: 'Daruma',
  [PrinterBrand.OTHER]: 'Outra',
};

export enum PrinterConnectionType {
  NETWORK = 'NETWORK',
  USB = 'USB',
}

export enum PaperWidth {
  MM58 = '58mm',
  MM80 = '80mm',
}

export interface PrinterConfig {
  id: number;
  providerId: number;
  name: string;
  printerBrand: PrinterBrand;
  connectionType: PrinterConnectionType;
  host: string | null;
  port: number | null;
  paperWidth: PaperWidth;
  isDefault: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface PrinterStatus {
  hasNetworkPrinter: boolean;
  defaultPrinter: PrinterConfig | null;
  printMethod: 'network' | 'browser';
}

export interface CreatePrinterConfigData {
  providerId: number;
  name: string;
  printerBrand: PrinterBrand;
  connectionType: PrinterConnectionType;
  host?: string | null;
  port?: number | null;
  paperWidth?: PaperWidth;
  isDefault?: boolean;
}

export interface UpdatePrinterConfigData {
  name?: string;
  printerBrand?: PrinterBrand;
  connectionType?: PrinterConnectionType;
  host?: string | null;
  port?: number | null;
  paperWidth?: PaperWidth;
  isDefault?: boolean;
  isActive?: boolean;
}

export interface TicketData {
  queueNumber: number;
  patientName: string;
  companyName: string | null;
  examType: string | null;
  time: string;
  date: string;
  providerName: string;
}

export interface PrintResult {
  success: boolean;
  method: 'network' | 'browser';
}

export interface TestConnectionResult {
  success: boolean;
  message: string;
}
